import {IntegrationAuthorization} from './IntegrationDesign';
import {integrationActions} from "../../../store/actions/integrationAction";
import {connect} from "react-redux";
import {useEffect} from "react";

function MicrosoftLoginRedirect(props) {
    const {history, integration, getMicrosoftLoginLink, alert} = props;

    useEffect(() => {
        if (integration.selectedIntegration.name === "Microsoft Ads") {
            getMicrosoftLoginLink();
        }
    }, [getMicrosoftLoginLink, integration?.selectedIntegration?.name]);

    useEffect(() => {
        if (integration?.microsoft?.loginLink !== null) {
            document.location.href = integration?.microsoft?.loginLink;
        }
    }, [integration?.microsoft?.loginLink])

    useEffect(() => {
        if (alert.errorMsg !== "") {
            history.push({pathname: "/settings/integrations"});
        }
    }, [history, alert?.errorMsg])

    return <IntegrationAuthorization name="Microsoft"/>;
}

const mapStateToProps = (state) => {
    return {
        integration: state.integration,
        alert: state.alert
    };
};

const mapDispatchToProps = {
    getMicrosoftLoginLink: integrationActions.getMicrosoftLoginLink
};

export default connect(mapStateToProps, mapDispatchToProps)(MicrosoftLoginRedirect);
